module.exports = __webpack_public_path__ + "img/price-card-1.d8254820.jpg";